import createRoutine from '@/utils/createRoutine'

export const companyOpportunitiesRoutine = createRoutine('companyOpportunitiesRoutine')
export const aggregatorOpportunityIdRoutine = createRoutine('aggregatorOpportunityIdRoutine')
export const aggregatorFormSubmittedRoutine = createRoutine('aggregatorFormSubmittedRoutine')

export const aggregatorGetters = {
  COMPANY_OPPORTUNITIES: 'COMPANY_OPPORTUNITIES',
  AGGREGATOR_OPPORTUNITY_ID: 'AGGREGATOR_OPPORTUNITY_ID',
  IS_ILO_FORM_SUBMITTED: 'IS_ILO_FORM_SUBMITTED'
}
export const OPPORTUNITY_CLEANUP = 'OPPORTUNITY_CLEANUP'
